export const SHOW_LOADING = "@Kenta/SHOW_LOADING";
export const HIDE_LOADING = "@Kenta/HIDE_LOADING";
